import React, { createContext, useState } from 'react'
import { getOrderDataById } from '../api'
import { fetchData } from '../../../global/utils/fetch'
import { initialOrderData } from './constants'
import { IOrder } from '../../../../../app/entities/Order'
interface IContextProps {
  queryOrderData: (id: string | undefined) => Promise<IOrder>
  clearData: () => void
  data: IOrder
  isLoading: boolean
}

interface IProviderProps {
  children: React.ReactNode
}

export const WoDetailContext = createContext<IContextProps>({} as IContextProps)

export const WoDetailContextProvider = ({ children }: IProviderProps) => {
  const [data, setData] = useState<IOrder>(initialOrderData)
  const [isLoading, setIsLoading] = useState(false)

  const queryOrderData = async (orderObjectId: string | undefined) => {
    setIsLoading(true)
    try {
      const orderResults = await fetchData<IOrder>(
        getOrderDataById(orderObjectId),
      )
      setData(orderResults)
      return orderResults
    } catch (error) {
      console.error('Failed to fetch order data.', error)
      throw error
    } finally {
      setIsLoading(false)
    }
  }
  const clearData = () => {
    setData(initialOrderData)
  }
  return (
    <WoDetailContext.Provider
      value={{
        queryOrderData,
        clearData,
        data,
        isLoading,
      }}
    >
      {children}
    </WoDetailContext.Provider>
  )
}
